import * as React from 'react';
import type { ReactNode } from 'react';

import type { HeaderLevel } from '@coursera-web/cds-labs';
import { headerOrder } from '@coursera-web/cds-labs';

import { HeaderLevelContext } from 'bundles/page-config-common/contexts/HeaderLevelContext';

/**
 * @description This provider is used to set the header level of the page config component titles
 */
const HeaderLevelProvider = ({
  initialLevel = 'h2',
  children,
}: {
  initialLevel?: HeaderLevel;
  children: ReactNode;
}) => {
  const nextLevel = headerOrder[Math.min(headerOrder.indexOf(initialLevel) + 1, headerOrder.length - 1)];

  return (
    <HeaderLevelContext.Provider
      value={{
        currentLevel: initialLevel,
        // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        nextLevel,
      }}
    >
      {children}
    </HeaderLevelContext.Provider>
  );
};

export default HeaderLevelProvider;
